<template>
  <div id="settings">
    <v-btn class="action" color="primary" :disabled="loading" @click="save">
      Save
    </v-btn>
    <v-btn class="action" color="grey" dark @click="refresh">Refresh</v-btn>
    <v-container v-if="!loading" fluid>
      <v-tabs v-model="tab">
        <v-tab v-for="(c, i) of tabs" :key="c" :value="i">
          {{ c.replace(/([A-Z])/g, " $1") }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="c of tabs" :key="c">
          <v-card flat>
            <prism-editor
              class="my-editor"
              v-model="settings[c]"
              language="json"
              :highlight="highlighter"
            ></prism-editor>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
    <v-container fill-height fluid class="load-parent">
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
        class="loader"
      ></v-progress-circular>
    </v-container>
  </div>
</template>

<script>
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";

import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-yaml";
import "prismjs/themes/prism-coy.css";

import { readConfig, saveConfig } from "../lib/config";

export default {
  name: "Settings",
  components: {
    PrismEditor
  },
  data() {
    return {
      loading: true,
      tab: null,
      settings: {},
      tab_order: ["Instance", "BetPlacement", "Bookie", "RaceMonitoring"]
    };
  },
  computed: {
    tabs() {
      return Object.keys(this.settings).sort(
        (a, b) => this.tab_order.indexOf(a) - this.tab_order.indexOf(b)
      );
    }
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.yaml);
    },
    async save() {
      try {
        this.loading = true;
        for (const setting of Object.values(this.settings)) {
          if (!setting.trim()) throw new Error("Invalid settings");
        }
        await saveConfig(this.settings);
        this.loading = false;
      } catch (err) {
        this.showError(`Unable to save config - ${err}`);
      }
    },
    async refresh() {
      try {
        this.loading = true;
        const { config } = await readConfig();
        this.settings = config;
        this.loading = false;
      } catch (err) {
        this.showError(`Unable to read config - ${err}`);
      }
    }
  },
  async mounted() {
    this.refresh();
  }
};
</script>

<style lang="scss">
// optional class for removing the outline
.prism-editor__textarea:focus {
  outline: none;
}

.my-editor {
  // you must provide font-family font-size line-height. Example:
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

#settings {
  .action {
    margin-bottom: 20px;
    margin: 4px;
  }

  .load-parent {
    min-height: 300px;
    width: 100%;

    .loader {
      margin: auto;
    }
  }
}
</style>
